import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule,PreloadAllModules } from '@angular/router';
import { LeadsRoutingModule } from './leads-routing.module';
import { LeadComponent } from '../leads/components/lead.component';
import { SettingsComponent } from '../leads/components/settings.component';
import { DetailComponent } from '../leads/components/detail.component';
import { LeadCrudComponent } from '../leads/components/lead-crud.component';
import { LeadService } from '../leads/services/lead.service';
import { GlobalDataService } from '../housekeeping/services/global-data.service';
import { FileUploadService } from '../housekeeping/services/file-upload.service';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/primeng';
import {LeadImportComponent} from '../leads/components/lead-import.component';
import {LeadExportComponent} from '../leads/components/lead-export.component';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { SortablejsModule } from 'angular-sortablejs';
import {RoleGuardService} from '../../role-guard.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { HousekeepingModule } from '../../../app/modules/housekeeping/housekeeping.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

const routes: Routes = [
  { path: 'leads', component: LeadComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/received/in/:email', component: LeadComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/settings', component: SettingsComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/detail/:id', component: DetailComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/create', component: LeadCrudComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/edit/:id', component: LeadCrudComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/export', component: LeadExportComponent ,canActivate :[RoleGuardService]},
   { path: 'leads/adhoc', component: LeadImportComponent ,canActivate: [RoleGuardService],
   },

];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LeadsRoutingModule,
    CalendarModule,
    Ng2AutoCompleteModule,
    HousekeepingModule,
    RouterModule.forRoot(routes,
      {
        useHash: false ,
        preloadingStrategy: PreloadAllModules
      }),
    // global settings
    SortablejsModule.forRoot({
      animation: 200,
    }),
    NgxPaginationModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  exports: [RouterModule],
  providers: [LeadService,GlobalDataService,FileUploadService,RoleGuardService],
  declarations: [LeadComponent, SettingsComponent, DetailComponent, LeadCrudComponent, LeadImportComponent,LeadExportComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class LeadsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/leads/leads.module.ts